<!--
  The view selector is rendered by each of the two views rather than here, so
  that it shares a row with that view's own filter checkboxes — see
  <app-reservations-view-toggle>.
-->
<router-outlet></router-outlet>
